import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import uploadImagetow from '@/components/uploadImagetow';
import { serverList, vipUserActive } from "@/api/gmtool/packageCode";
import { gmToolNew, gmTool, serchSelect } from "@/mixins/index";
export default {
  name: "vipActivation",
  mixins: [gmToolNew, gmTool, serchSelect],
  data: function data() {
    return {
      advanced: false,
      currentPage: 1,
      tableData: [],
      exportLoading: false,
      paramsData: {
        // page: 1,
        is_recalled: ''
      },
      date: [],
      total: 0,
      options: [],
      stateType: [{
        value: 1,
        label: this.$t('recalled')
      }, {
        value: 2,
        label: this.$t('notRecalled')
      }],
      serverLis: []
    };
  },
  created: function created() {
    var time = this.$times.timestampToTime(this.$times.zeroTimeZone() / 1000, 'YY-MM-DD');
    this.date[0] = time;
    this.date[1] = time;
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.paramsData.start_time = _this.date && _this.date[0];
                _this.paramsData.end_time = _this.date && _this.date[1];
                _this.reqLoading = true;
                vipUserActive(_objectSpread(_objectSpread({}, _this.paramsData), {}, {
                  game_id: _this.rawData.game_id
                })).then(function (res) {
                  if (res.status == 200) {
                    _this.tableData = res.data;

                    _this.tableData.forEach(function (item) {
                      item.vip_recharge_amount = item.vip_recharge_amount / 100 || 0;
                    });
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    exportdata: function exportdata() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var columns;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                columns = [{
                  label: _this2.$t('date'),
                  prop: 'date'
                }, {
                  label: _this2.$t('newVipCount'),
                  prop: 'new_vip_count'
                }, {
                  label: _this2.$t('vipLoginCount'),
                  prop: 'vip_login_count'
                }, {
                  label: _this2.$t('vipRechargeCount'),
                  prop: 'vip_recharge_count'
                }, {
                  label: _this2.$t('vipRechargeAmount'),
                  prop: 'vip_recharge_amount'
                }];

                _this2.$export.excel({
                  columns: columns,
                  data: _this2.tableData,
                  title: _this2.$t('vipUserActivity')
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};